// extracted by mini-css-extract-plugin
module.exports = {"ldsRoller":"Loading_ldsRoller__p7djJ","lds-roller":"Loading_lds-roller__UEQ99"};